export default __webpack_public_path__ + "static/media/hand-image-8.85237a48.webp";